import Vue from 'vue'
import Router from 'vue-router'

import utils from '@/lib/utils'

Vue.use(Router)
let routes = []

// add these first to ensure they are matched first
const numeraiRoutes = [
  {
    path: '/earn',
    redirect: '/tutorial',
  },
  {
    path: '/tutorial',
    redirect: '/tutorial/hello-numerai',
  },
  {
    path: '/tutorial',
    // https://github.com/vuejs/vue-router/issues/2105#issuecomment-678980641
    component: {
      render: c => c('router-view'),
    },
    name: 'tutorial',
    props: true,
    children: [
      {
        path: 'hello-numerai',
        component: () => import('@/pages/TutorialHelloNumerai.vue'),
        name: 'Hello Numerai',
        props: true,
      },
      {
        path: 'feature-neutralization',
        component: () => import('@/pages/TutorialFeatureNeutralization.vue'),
        name: 'Feature Neutralization',
        props: true,
      },
      {
        path: 'target-ensemble',
        component: () => import('@/pages/TutorialTargetEnsemble.vue'),
        name: 'Target Ensemble',
        props: true,
      },
    ],
  },
]

// add these first to ensure they are matched first
const cryptoSignalsRoutes = [
  {
    path: '/meta-model',
    name: 'Meta Model',
    component: () => import('@/pages/MetaModelPage.vue'),
  },
]

if (utils.isAppClassic()) {
  routes = routes.concat(numeraiRoutes)
}
if (utils.isAppCryptoSignals()) {
  routes = routes.concat(cryptoSignalsRoutes)
}

routes = routes.concat([
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/pages/HomePage.vue'),
  },
  {
    path: '/tournament',
    redirect: '/leaderboard',
  },
  {
    path: '/leaderboard',
    name: 'Leaderboard',
    component: () => import('@/pages/TournamentPage.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/Login.vue'),
  },
  {
    path: '/sso',
    name: 'Single-Sign-On',
    component: () => import('@/pages/SingleSignOn.vue'),
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import('@/pages/Signup.vue'),
  },
  {
    path: '/season',
    name: 'Season',
    component: () => import('@/pages/SeasonPage.vue'),
  },
  {
    path: '/data',
    component: () => import('@/pages/DataPage.vue'),
    props: true,
    children: [
      {
        path: '',
        component: () => import('@/pages/DataPage.vue'),
      },
      {
        path: ':version',
        component: () => import('@/pages/DataPage.vue'),
        name: 'Data',
        props: true,
      },
    ],
  },
  {
    path: '/models',
    name: 'Models',
    component: () => import('@/pages/ModelsPage.vue'),
    props: true,
  },
  {
    path: '/staking',
    name: 'Staking',
    component: () => import('@/pages/StakingPage.vue'),
    props: true,
  },
  {
    path: '/submissions',
    name: 'Submissions',
    component: () => import('@/pages/SubmissionsPage.vue'),
    props: true,
  },
  {
    path: '/scores',
    name: 'Scores',
    component: () => import('@/pages/ScoresPage.vue'),
    props: true,
  },
  {
    path: '/nftee/:voucher',
    name: 'NFTee Voucher',
    component: () => import('@/pages/NftPage.vue'),
  },
  {
    path: '/reset',
    name: 'Reset Password',
    component: () => import('@/pages/ResetPassword.vue'),
  },
  {
    path: '/reset-password/u/:token',
    name: 'Confirm Password Reset',
    component: () => import('@/pages/ConfirmResetPassword.vue'),
  },
  {
    path: '/confirm/:token',
    name: 'Confirm Signup',
    component: () => import('@/pages/ConfirmSignup.vue'),
  },
  {
    path: '/verify/:token',
    name: 'Verify Email',
    component: () => import('@/pages/VerifyEmail.vue'),
  },
  {
    path: '/reset-email/:token',
    name: 'Reset Email',
    component: () => import('@/pages/ResetEmail.vue'),
  },
  {
    path: '/verify-ip/:token',
    name: 'Verify IP',
    component: () => import('@/pages/VerifyIP.vue'),
  },
  {
    path: '/unsubscribe/:type/:token',
    name: 'Unsubscribe',
    component: () => import('@/pages/Unsubscribe.vue'),
  },
  {
    path: '/round/:number',
    name: 'Details',
    component: () => import('@/pages/RoundPage.vue'),
    props: true,
  },
  {
    path: '/account',
    name: 'Account Settings',
    component: () => import('@/pages/Account.vue'),
  },

  {
    path: '/wallet',
    name: 'Wallet',
    component: () => import('@/pages/Wallet.vue'),
  },
  {
    path: '/legal',
    name: 'Legal',
    component: () => import('@/pages/Legal.vue'),
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('@/pages/Legal.vue'),
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/pages/Privacy.vue'),
  },
  {
    path: '/nftee',
    name: 'NFTees',
    component: () => import('@/pages/NftPage.vue'),
  },
  {
    path: '/~:accountname',
    name: 'Account Profile',
    component: () => import('@/pages/AccountProfilePage.vue'),
    props: true,
  },
  {
    path: '/:username',
    component: () => import('@/pages/ProfilePage.vue'),
    props: true,
    children: [
      {
        path: '',
        component: () => import('@/components/profile/ProfileOverview.vue'),
        name: 'Profile',
        props: true,
      },
      {
        path: 'submissions/:round',
        component: () => import('@/components/profile/ProfileSubmission.vue'),
        name: 'Submission',
        props: true,
      },
      {
        path: 'settings',
        component: () => import('@/components/profile/ProfileSettings.vue'),
        name: 'Settings',
        props: true,
      },
    ],
  },
])

// add this route at the end
routes.push({
  path: '*',
  name: 'page-not-found',
  component: () => import('@/pages/PageNotFound.vue'),
})

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

// helper to redirect with delay
router.delayRedirect = function(name) {
  setTimeout(() => {
    router.push(name)
  }, 3000)
}

function tournamentNameSuffix() {
  if (utils.isAppSignals()) {
    return ' Signals'
  } else if (utils.isAppCryptoSignals()) {
    return ' Crypto'
  } else {
    return ''
  }
}

router.afterEach(to => {
  Vue.nextTick(() => {
    let docTitle = `Numerai${tournamentNameSuffix()}`
    if (to.name !== null) {
      docTitle = `${to.name} - ${docTitle}`
    }
    if (to.params.accountname) {
      docTitle = `${to.params.accountname.toLocaleUpperCase()} ${docTitle}`
    }
    if (to.params.username) {
      docTitle = `${to.params.username.toLocaleUpperCase()} ${docTitle}`
    }
    if (to.params.number) {
      docTitle = `Round ${to.params.number} ${docTitle}`
    }
    if (to.params.round) {
      docTitle = `Round ${to.params.round} ${docTitle}`
    }
    if (to.params.version) {
      docTitle = `${to.params.version} ${docTitle}`
    }
    document.title = docTitle

    const urlParams = new URLSearchParams(window.location.search)
    const utm_source = urlParams.get('utm_source')
    const utm_medium = urlParams.get('utm_medium')
    const utm_campaign = urlParams.get('utm_campaign')

    /* global gtag */
    if (typeof window.gtag === 'function') {
      gtag('event', 'page_view', {
        page_path: to.fullPath,
        page_title: docTitle,
        page_location: window.location.href,
        ...(utm_source && { utm_source }),
        ...(utm_medium && { utm_medium }),
        ...(utm_campaign && { utm_campaign }),
      })
    }
  })
})

export default router
